class HeaderDrawer extends window.SlideOutPanel {
  onConnected() {
    this.bindSubmenuEvents();
  }

  handleDocumentClick(event) {
    const trigger = event.target.closest(this.openTriggerSelector);
    if (!trigger) return;

    event.preventDefault();

    if (this.classList.contains('is-open')) {
      this.close();
      return;
    }

    this.open({
      trigger,
      ...this.getOpenOptionsFromTrigger(trigger),
    });
  }

  syncTriggerState(isOpen) {
    document.querySelectorAll(this.openTriggerSelector).forEach((trigger) => {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  onAfterOpen() {
    this.syncTriggerState(true);
  }

  onAfterClose() {
    this.syncTriggerState(false);
  }

  bindSubmenuEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');
      if (summary.nextElementSibling?.id) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
      }
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    });

    this.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (isOpen) {
      event.preventDefault();
      this.closeSubmenu(detailsElement);
      return;
    }

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', 'true');
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onBeforeClose() {
    this.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }
}

if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', HeaderDrawer);
}
